// Ported verbatim from studio_v4.html TEMPLATES registry + helpers.
export const DEMO_MP4 = "https://storage.googleapis.com/interactive-media-ads/media/android.mp4";
export const DEMO_HLS = "https://test-streams.mux.dev/x36xhzz/url_6/193039199_mp4_h264_aac_hq_7.m3u8";

export function guessKind(u) { return /\.m3u8(\?|$)/i.test(u) ? "hls" : "mp4"; }
export function pickPreviewSrc(bg) {
  const vs = (bg && bg.videos) || [];
  for (let i = 0; i < vs.length; i++) if (vs[i].kind === "hls" && vs[i].url) return vs[i];
  for (let j = 0; j < vs.length; j++) if (vs[j].url) return vs[j];
  return null;
}
export function toHex(v) {
  v = String(v || "").trim();
  if (/^#[0-9a-fA-F]{6}$/.test(v)) return v;
  if (/^#[0-9a-fA-F]{3}$/.test(v)) return "#" + v.slice(1).split("").map((x) => x + x).join("");
  return "#888888";
}
export function uid() { return "c" + Math.random().toString(36).slice(2, 9); }
export const qrUrl = (link) => (link ? `${process.env.REACT_APP_BACKEND_URL || ""}/api/qr?data=${encodeURIComponent(link)}` : "");

export const TEMPLATES = {
  carousel: {
    name: "Carousel", tier: "Tier A",
    desc: "Browse product frames with ← →. OK opens the CTA.",
    layouts: [{ id: "bottom", name: "Bottom strip" }, { id: "side", name: "Side rail" }],
    defaults: () => ({
      background: { type: "video", image: "", videos: [{ url: DEMO_MP4, kind: "mp4", bitrate: 1500, w: 1280, h: 720 }] }, layout: "bottom", duration: 15,
      advertiser: "Maybelline", brand: "#7A5FA3", btnFill: "#F5A524", btnText: "#1A1205", cta: "Shop this shade",
      frames: [
        { label: "Shade 01 — Fair", img: "", color: "#e9c9ad", url: "https://example.com/01" },
        { label: "Shade 02 — Medium", img: "", color: "#cf9b6d", url: "https://example.com/02" },
        { label: "Shade 03 — Tan", img: "", color: "#a9744a", url: "https://example.com/03" },
      ],
    }),
    content: [
      { group: "Brand", fields: [{ key: "advertiser", label: "Advertiser name", type: "text" }, { key: "brand", label: "Brand accent", type: "color" }] },
      { group: "Call to action", fields: [{ key: "cta", label: "Button label", type: "text" }, { key: "btnFill", label: "Button color", type: "color" }, { key: "btnText", label: "Button text color", type: "color" }] },
      { group: "Frames", list: "frames", min: 2, max: 6, itemLabel: "Frame", item: [{ key: "label", label: "Headline", type: "text" }, { key: "img", label: "Image (URL or upload)", type: "image" }, { key: "color", label: "Fallback color", type: "color" }, { key: "url", label: "Click-through URL", type: "url" }] },
    ],
  },
  poll: {
    name: "Poll", tier: "Tier A",
    desc: "Vote with ← → and OK. Sits low so the video breathes.",
    layouts: [{ id: "lower", name: "Lower third" }, { id: "center", name: "Center" }, { id: "side", name: "Side panel" }],
    defaults: () => ({
      background: { type: "video", image: "", videos: [{ url: DEMO_MP4, kind: "mp4", bitrate: 1500, w: 1280, h: 720 }] }, layout: "lower", duration: 15,
      advertiser: "Netflix", brand: "#E50914", btnFill: "#E50914", btnText: "#FFFFFF",
      question: "Just had an argument with your partner — what do you do?",
      resultCopy: "Thanks for voting — streaming Oct 23.",
      options: [{ label: "Talk it out" }, { label: "Give it space" }],
    }),
    content: [
      { group: "Brand", fields: [{ key: "advertiser", label: "Advertiser name", type: "text" }, { key: "brand", label: "Brand accent", type: "color" }] },
      { group: "Poll", fields: [{ key: "question", label: "Question", type: "textarea" }, { key: "resultCopy", label: "Result message", type: "text" }] },
      { group: "Selection style", fields: [{ key: "btnFill", label: "Highlight color", type: "color" }, { key: "btnText", label: "Highlight text", type: "color" }] },
      { group: "Options", list: "options", min: 2, max: 4, itemLabel: "Option", item: [{ key: "label", label: "Answer", type: "text" }] },
    ],
  },
  qr: {
    name: "QR / Send-to-phone", tier: "Tier A",
    desc: "Overlay, or split with media left / panel right.",
    layouts: [{ id: "overlay", name: "Overlay" }, { id: "split", name: "Split · media left" }, { id: "banner", name: "Bottom banner" }],
    defaults: () => ({
      background: { type: "image", image: "", videos: [] }, layout: "split", duration: 10,
      advertiser: "Adidas", brand: "#0A8A5F", btnFill: "#0A8A5F", btnText: "#FFFFFF",
      headline: "Scan to get 20% off", sub: "Point your phone at the code", cta: "adidas.com/offer",
      qrLink: "https://adidas.com/offer", qrImg: qrUrl("https://adidas.com/offer"),
    }),
    content: [
      { group: "Brand", fields: [{ key: "advertiser", label: "Advertiser name", type: "text" }, { key: "brand", label: "Brand accent", type: "color" }] },
      { group: "Message", fields: [{ key: "headline", label: "Headline", type: "text" }, { key: "sub", label: "Sub-line", type: "text" }, { key: "cta", label: "URL caption", type: "text" }] },
      { group: "QR", fields: [{ key: "qrLink", label: "Destination link — auto-generates a scannable code", type: "qrgen" }, { key: "qrImg", label: "…or use your own QR image (URL/upload)", type: "image" }, { key: "btnFill", label: "Panel color", type: "color" }, { key: "btnText", label: "Panel text", type: "color" }] },
    ],
  },
};

export function miniFor(tid) {
  if (tid === "carousel") return '<svg class="mini" viewBox="0 0 160 90" preserveAspectRatio="none"><rect x="46" y="20" width="68" height="42" rx="4" fill="#7A5FA3"/><rect x="20" y="30" width="20" height="24" rx="3" fill="#ffffff22"/><rect x="120" y="30" width="20" height="24" rx="3" fill="#ffffff22"/><rect x="62" y="70" width="36" height="6" rx="3" fill="#F5A524"/></svg>';
  if (tid === "poll") return '<svg class="mini" viewBox="0 0 160 90" preserveAspectRatio="none"><rect x="30" y="54" width="46" height="22" rx="5" fill="#E50914"/><rect x="84" y="54" width="46" height="22" rx="5" fill="#ffffff1a" stroke="#ffffff40"/><rect x="40" y="34" width="80" height="7" rx="3" fill="#ffffff40"/></svg>';
  return '<svg class="mini" viewBox="0 0 160 90" preserveAspectRatio="none"><rect x="0" y="0" width="96" height="90" fill="#12233b"/><rect x="96" y="0" width="64" height="90" fill="#0A8A5F"/><rect x="112" y="26" width="32" height="32" rx="3" fill="#fff"/></svg>';
}
